module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ack"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("This book is the result of many people’s generous efforts and much grace. Accordingly, we thank Joe O’Donnell, Penny Armstrong, and Brownie Anderson for their wise assistance; Tom Mellers for permissions help; and Samita Sinha and Diane Wachtell at The New Press for their direction, help, advice, and humor.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "fmtx1d"
  }, [_vm._v("—ROBERT COLES AND RANDY TESTA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3968b8e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/robe_9781595587800_oeb_ack_r1.vue
// module id = 66
// module chunks = 0